import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Download, FileAudio, Music } from "lucide-react";
import api, { API, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function DownloadModal({ open, onClose, song }) {
  const [loading, setLoading] = useState("");
  if (!song) return null;

  const dl = async (format) => {
    setLoading(format);
    try {
      const res = await api.get(`/songs/${song.id}/download`, { params: { format }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      const safe = (song.title || "track").replace(/[^a-z0-9 \-_]/gi, "");
      a.download = `${safe} - ${song.creator_name || "JixxeoX"}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${format.toUpperCase()} download started`);
      onClose();
    } catch (e) {
      // blob error → read text
      if (e.response?.data instanceof Blob) {
        const text = await e.response.data.text();
        try { toast.error(JSON.parse(text).detail || "Download failed"); }
        catch { toast.error("Download failed"); }
      } else toast.error(errMsg(e));
    }
    setLoading("");
  };

  const dl_ok = song.downloads || {};
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="jx-glass border-white/10" data-testid="download-modal">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Download size={18} className="text-purple-400" /> Download "{song.title}"</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-400 -mt-2">Choose a format. Downloads respect the creator's permissions and licensing.</p>
        <button onClick={() => dl("mp3")} disabled={loading} data-testid="download-mp3-btn"
          className="flex items-center gap-3 p-4 rounded-xl border border-white/10 hover:border-purple-500/40 transition-colors text-left">
          <Music className="text-purple-400" />
          <div className="flex-1"><p className="font-semibold">MP3</p><p className="text-xs text-slate-400">Convenient for everyday listening</p></div>
          {loading === "mp3" && <span className="text-xs text-slate-400">Preparing…</span>}
        </button>
        <button onClick={() => dl("wav")} disabled={loading} data-testid="download-wav-btn"
          className="flex items-center gap-3 p-4 rounded-xl border border-white/10 hover:border-cyan-500/40 transition-colors text-left">
          <FileAudio className="text-cyan-400" />
          <div className="flex-1"><p className="font-semibold">WAV</p><p className="text-xs text-slate-400">Higher-quality audio when available</p></div>
          {loading === "wav" && <span className="text-xs text-slate-400">Preparing…</span>}
        </button>
      </DialogContent>
    </Dialog>
  );
}
